<template>
  <b-row>
    <StepperCol :step="11" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        室外機までの距離は4m以内ですか？
      </h5>
      <b-collapse v-if="!skipped" v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{ a0Selected ? "4m以内" : a1Selected ? "5m": a2Selected ? '6m': a3Selected ? '8m':  a4Selected? '9m': '10m' }}</span>
          <div class="d-block text-muted">
            {{ a0Selected ? "¥0-" : a1Selected ? "¥4,400": a2Selected ? '¥8,800': a3Selected ? '¥13,200':  a4Selected? '¥17,600': '¥22,000' }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <h5 v-if="skipped" class="text-muted">同じ階に設置できないため省略</h5>
      <b-collapse v-else v-model="isCollapsed">
        <b-form-row>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-2 h-145px q1"
              :class="a0Selected ? 'selected' : ''"
              @click="buttonClicked(0)"
            >
              <div
                class="position-relative bg-contain h-100"
                :style="
                  'background-image: url(' +
                  require('@/assets/images/q-7-1@2x.png') +
                  ')'
                "
              >
                <h6
                  class="h4 pt-2 px-3 position-absolute"
                  style="top: 0; right: 0"
                >
                  4m以内
                </h6>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 10px; left: 15px"
                >
                  <dt>追加工事</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">0-</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left h-145px p-0 q1"
              :class="a1Selected ? 'selected' : ''"
              @click="buttonClicked(1)"
            >
              <div
                class="position-relative bg-cover h-100"
                :style="
                  'background-image: url(' +
                  require('@/assets/images/q-7-2@2x.png') +
                  ')'
                "
              >
                <h6
                  class="h4 pt-2 px-3 position-absolute"
                  style="top: 0; right: 0"
                >
                  5m
                </h6>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 10px; left: 15px"
                >
                  <dt>追加工事<br />延長配管1m</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">4,400</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left h-145px p-0 q1"
              :class="a2Selected ? 'selected' : ''"
              @click="buttonClicked(2)"
            >
              <div
                class="position-relative bg-cover h-100"
                :style="
                  'background-image: url(' +
                  require('@/assets/images/q-7-2@2x.png') +
                  ')'
                "
              >
                <h6
                  class="h4 pt-2 px-3 position-absolute"
                  style="top: 0; right: 0"
                >
                  6m
                </h6>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 10px; left: 15px"
                >
                  <dt>追加工事<br />延長配管2m</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">8,800</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left h-145px p-0 q1"
              :class="a3Selected ? 'selected' : ''"
              @click="buttonClicked(3)"
            >
              <div
                class="position-relative bg-cover h-100"
                :style="
                  'background-image: url(' +
                  require('@/assets/images/q-7-2@2x.png') +
                  ')'
                "
              >
                <h6
                  class="h4 pt-2 px-3 position-absolute"
                  style="top: 0; right: 0"
                >
                  7m
                </h6>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 10px; left: 15px"
                >
                  <dt>追加工事<br />延長配管3m</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">13,200</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left h-145px p-0 q1"
              :class="a4Selected ? 'selected' : ''"
              @click="buttonClicked(4)"
            >
              <div
                class="position-relative bg-cover h-100"
                :style="
                  'background-image: url(' +
                  require('@/assets/images/q-7-2@2x.png') +
                  ')'
                "
              >
                <h6
                  class="h4 pt-2 px-3 position-absolute"
                  style="top: 0; right: 0"
                >
                  8m
                </h6>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 10px; left: 15px"
                >
                  <dt>追加工事<br />延長配管4m</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">17,600</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left h-145px p-0 q1"
              :class="a5Selected ? 'selected' : ''"
              @click="buttonClicked(5)"
            >
              <div
                class="position-relative bg-cover h-100"
                :style="
                  'background-image: url(' +
                  require('@/assets/images/q-7-2@2x.png') +
                  ')'
                "
              >
                <h6
                  class="h4 pt-2 px-3 position-absolute"
                  style="top: 0; right: 0"
                >
                  9m
                </h6>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 10px; left: 15px"
                >
                  <dt>追加工事<br />延長配管5m</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">22,000</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
        </b-form-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
      a2Selected: false,
      a3Selected: false,
      a4Selected: false,
      a5Selected: false,
      skipped: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 11) {
        this.collapsed = true;
      }
    },
    sameFloor(val, old) {
      old; // eslint-disable-line
      if (val == 1 || val == 2) {
        this.skipped = true;
        this.a0Selected = true;
        this.a1Selected = false;
        this.a2Selected = false;
        this.a3Selected = false;
        this.a4Selected = false;
        this.a5Selected = false;
      } else {
        this.skipped = false;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
      sameFloor() {
        return this.$store.getters.sameFloor;
      },

    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
      this.a2Selected = false;
      this.a3Selected = false;
      this.a4Selected = false;
      this.a5Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
        this.a2Selected = false;
        this.a3Selected = false;
        this.a4Selected = false;
        this.a5Selected = false;
      } else if (value == 1) {
        this.a0Selected = false;
        this.a1Selected = true;
        this.a2Selected = false;
        this.a3Selected = false;
        this.a4Selected = false;
        this.a5Selected = false;
      } else if (value == 2) {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = true;
        this.a3Selected = false;
        this.a4Selected = false;
        this.a5Selected = false;
      }  else if (value == 3) {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = false;
        this.a3Selected = true;
        this.a4Selected = false;
        this.a5Selected = false;
      }  else if (value == 4) {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = false;
        this.a3Selected = false;
        this.a4Selected = true;
        this.a5Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = false;
        this.a3Selected = false;
        this.a4Selected = false;
        this.a5Selected = true;
      }
      this.doSaveAnswer({ keyword: 'extention_tube', answer: value });
      this.doUpdateStep(12);
      this.shrinking = true;
      if (this.$gtag) {
        console.log("google:室外機までの距離は4m以内ですか？");
        this.$gtag.event("入力", {
          event_category: "選択",
          event_label: "STEP10",
          value: "室外機までの距離は4m以内ですか？",
        });
      }
    },
  },
};
</script>